<template>
<div class="chapter">
<div class="inner_page">
<section class="titlepage" epub:type="titlepage">
<div class="title">
<h1>Jello Salad</h1>
<h2>Nicholas Blincoe</h2>
</div>
<div class="canelo"><img alt="Canelo" height="30" src="images/scale~1920x1200~canelotitle-1454015556-29.png" style="height:30px;width:129px;" width="129"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter0.vue?18c8a0fe